module.exports = __webpack_public_path__ + "img/covid_cases_071122KV.bd19df50.jpg";